import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "fields"];
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import { Box } from 'components/Flex';
import OverflowTooltip from 'components/OverflowTooltip';
import TextLink from 'components/TextLink';
import useUniqueId from 'hooks/useUniqueId';
var UrlField = function UrlField(_ref) {
  var id = _ref.id,
    fields = _ref.fields,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var webUrl = fields.webUrl;
  return /*#__PURE__*/React.createElement(FormField, _extends({
    label: t('form_url_colon'),
    labelId: uniqueId
  }, otherProps), /*#__PURE__*/React.createElement(OverflowTooltip, {
    content: webUrl.value
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    mr: "s",
    overflow: "ellipsis"
  }, /*#__PURE__*/React.createElement(TextLink, {
    target: "_blank",
    href: webUrl.value,
    title: webUrl.value
  }, webUrl.value))));
};
export default UrlField;